/**
 * @param {object} $element - jQuery element
 * @param {object} $ - jQuery
 */
function StickyElement($element, $) {
    var self = this;

    validateType('function', $);

    /**
     * "Lijepi" element na vrh stranice pri scrollu ispod granice.
     * @param {number} topBoundary
     * @param {string} stickyClass - klasa koja se dodijeli elementu pri "zalijepljenom" stanju
     */
    self.stickBelow = function (topBoundary, stickyClass) {
        stickyClass = stickyClass || {};

        validateType('number', topBoundary);
        validateType('string', stickyClass);

        $(window).on('scroll.stickyElement', function () {
            var windowTop = $(this).scrollTop();

            if (windowTop > topBoundary) {
                stickToTop(stickyClass);

                return;
            }

            unstickFromTop(stickyClass);
        });
    };

    self.unstick = function () {
        $(window).off('scroll.stickyElement');
    };

    function stickToTop(classToAdd) {
        var element = $element[0];

        element.style.removeProperty('position');
        element.style.removeProperty('top');
        element.style.setProperty('position', 'fixed', 'important');
        element.style.setProperty('top', '0');

        $element.addClass(classToAdd);
    }

    function unstickFromTop(classToRemove) {
        $element
            .css({position: '', top: ''})
            .removeClass(classToRemove);
    }

    function validateType(expected, actual) {
        for (var i = 1; i < arguments.length; i++) {
            if (typeof arguments[i] !== expected) {
                throw new TypeError('expected a ' + expected + ', got ' + typeof arguments[i]);
            }
        }
    }
}

StickyElement.prototype = {};

export default StickyElement;
